import { Boundries } from '../model/boundries.model';

const checkElementsOverlap = (element1Boundries: Boundries, element2Boundries: Boundries): boolean => {
  const overlap = !(
    element1Boundries.top > element2Boundries.bottom ||
    element1Boundries.right < element2Boundries.left ||
    element1Boundries.bottom < element2Boundries.top ||
    element1Boundries.left > element2Boundries.right
  );

  return overlap;
};

export default checkElementsOverlap;
